(function() {
  if (typeof document > "u" || "adoptedStyleSheets" in document)
    return;
  var t = "ShadyCSS" in window && !ShadyCSS.nativeShadow, e = document.implementation.createHTMLDocument(""), n = /* @__PURE__ */ new WeakMap(), a = typeof DOMException == "object" ? Error : DOMException, i = Object.defineProperty, l = Array.prototype.forEach, s = /@import.+?;?$/gm;
  function d(r) {
    var o = r.replace(s, "");
    return o !== r && console.warn("@import rules are not allowed here. See https://github.com/WICG/construct-stylesheets/issues/119#issuecomment-588352418"), o.trim();
  }
  function h(r) {
    return "isConnected" in r ? r.isConnected : document.contains(r);
  }
  function f(r) {
    return r.filter(function(o, c) {
      return r.indexOf(o) === c;
    });
  }
  function E(r, o) {
    return r.filter(function(c) {
      return o.indexOf(c) === -1;
    });
  }
  function xe(r) {
    r.parentNode.removeChild(r);
  }
  function ee(r) {
    return r.shadowRoot || n.get(r);
  }
  var Ne = [
    "addRule",
    "deleteRule",
    "insertRule",
    "removeRule"
  ], Ve = CSSStyleSheet, x = Ve.prototype;
  x.replace = function() {
    return Promise.reject(new a("Can't call replace on non-constructed CSSStyleSheets."));
  }, x.replaceSync = function() {
    throw new a("Failed to execute 'replaceSync' on 'CSSStyleSheet': Can't call replaceSync on non-constructed CSSStyleSheets.");
  };
  function te(r) {
    return typeof r == "object" ? F.isPrototypeOf(r) || x.isPrototypeOf(r) : !1;
  }
  function Oe(r) {
    return typeof r == "object" ? x.isPrototypeOf(r) : !1;
  }
  var S = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap(), V = /* @__PURE__ */ new WeakMap();
  function Re(r, o) {
    var c = document.createElement("style");
    return N.get(r).set(o, c), M.get(r).push(o), c;
  }
  function C(r, o) {
    return N.get(r).get(o);
  }
  function Pe(r, o) {
    N.get(r).delete(o), M.set(r, M.get(r).filter(function(c) {
      return c !== o;
    }));
  }
  function ne(r, o) {
    requestAnimationFrame(function() {
      o.textContent = S.get(r).textContent, V.get(r).forEach(function(c) {
        return o.sheet[c.method].apply(o.sheet, c.args);
      });
    });
  }
  function O(r) {
    if (!S.has(r))
      throw new TypeError("Illegal invocation");
  }
  function z() {
    var r = this, o = document.createElement("style");
    e.body.appendChild(o), S.set(r, o), M.set(r, []), N.set(r, /* @__PURE__ */ new WeakMap()), V.set(r, []);
  }
  var F = z.prototype;
  F.replace = function(o) {
    try {
      return this.replaceSync(o), Promise.resolve(this);
    } catch (c) {
      return Promise.reject(c);
    }
  }, F.replaceSync = function(o) {
    if (O(this), typeof o == "string") {
      var c = this;
      S.get(c).textContent = d(o), V.set(c, []), M.get(c).forEach(function(p) {
        p.isConnected() && ne(c, C(c, p));
      });
    }
  }, i(F, "cssRules", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return O(this), S.get(this).sheet.cssRules;
    }
  }), i(F, "media", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return O(this), S.get(this).sheet.media;
    }
  }), Ne.forEach(function(r) {
    F[r] = function() {
      var o = this;
      O(o);
      var c = arguments;
      V.get(o).push({ method: r, args: c }), M.get(o).forEach(function(m) {
        if (m.isConnected()) {
          var u = C(o, m).sheet;
          u[r].apply(u, c);
        }
      });
      var p = S.get(o).sheet;
      return p[r].apply(p, c);
    };
  }), i(z, Symbol.hasInstance, {
    configurable: !0,
    value: te
  });
  var ae = {
    childList: !0,
    subtree: !0
  }, re = /* @__PURE__ */ new WeakMap();
  function I(r) {
    var o = re.get(r);
    return o || (o = new se(r), re.set(r, o)), o;
  }
  function oe(r) {
    i(r.prototype, "adoptedStyleSheets", {
      configurable: !0,
      enumerable: !0,
      get: function() {
        return I(this).sheets;
      },
      set: function(o) {
        I(this).update(o);
      }
    });
  }
  function U(r, o) {
    for (var c = document.createNodeIterator(
      r,
      NodeFilter.SHOW_ELEMENT,
      function(m) {
        return ee(m) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
      null,
      !1
    ), p = void 0; p = c.nextNode(); )
      o(ee(p));
  }
  var R = /* @__PURE__ */ new WeakMap(), k = /* @__PURE__ */ new WeakMap(), P = /* @__PURE__ */ new WeakMap();
  function We(r, o) {
    return o instanceof HTMLStyleElement && k.get(r).some(function(c) {
      return C(c, r);
    });
  }
  function ie(r) {
    var o = R.get(r);
    return o instanceof Document ? o.body : o;
  }
  function K(r) {
    var o = document.createDocumentFragment(), c = k.get(r), p = P.get(r), m = ie(r);
    p.disconnect(), c.forEach(function(u) {
      o.appendChild(C(u, r) || Re(u, r));
    }), m.insertBefore(o, null), p.observe(m, ae), c.forEach(function(u) {
      ne(u, C(u, r));
    });
  }
  function se(r) {
    var o = this;
    o.sheets = [], R.set(o, r), k.set(o, []), P.set(o, new MutationObserver(function(c, p) {
      if (!document) {
        p.disconnect();
        return;
      }
      c.forEach(function(m) {
        t || l.call(m.addedNodes, function(u) {
          u instanceof Element && U(u, function(A) {
            I(A).connect();
          });
        }), l.call(m.removedNodes, function(u) {
          u instanceof Element && (We(o, u) && K(o), t || U(u, function(A) {
            I(A).disconnect();
          }));
        });
      });
    }));
  }
  if (se.prototype = {
    isConnected: function() {
      var r = R.get(this);
      return r instanceof Document ? r.readyState !== "loading" : h(r.host);
    },
    connect: function() {
      var r = ie(this);
      P.get(this).observe(r, ae), k.get(this).length > 0 && K(this), U(r, function(o) {
        I(o).connect();
      });
    },
    disconnect: function() {
      P.get(this).disconnect();
    },
    update: function(r) {
      var o = this, c = R.get(o) === document ? "Document" : "ShadowRoot";
      if (!Array.isArray(r))
        throw new TypeError("Failed to set the 'adoptedStyleSheets' property on " + c + ": Iterator getter is not callable.");
      if (!r.every(te))
        throw new TypeError("Failed to set the 'adoptedStyleSheets' property on " + c + ": Failed to convert value to 'CSSStyleSheet'");
      if (r.some(Oe))
        throw new TypeError("Failed to set the 'adoptedStyleSheets' property on " + c + ": Can't adopt non-constructed stylesheets");
      o.sheets = r;
      var p = k.get(o), m = f(r), u = E(p, m);
      u.forEach(function(A) {
        xe(C(A, o)), Pe(A, o);
      }), k.set(o, m), o.isConnected() && m.length > 0 && K(o);
    }
  }, window.CSSStyleSheet = z, oe(Document), "ShadowRoot" in window) {
    oe(ShadowRoot);
    var le = Element.prototype, De = le.attachShadow;
    le.attachShadow = function(o) {
      var c = De.call(this, o);
      return o.mode === "closed" && n.set(this, c), c;
    };
  }
  var W = I(document);
  W.isConnected() ? W.connect() : document.addEventListener("DOMContentLoaded", W.connect.bind(W));
})();
const g = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap(), L = /* @__PURE__ */ new WeakMap(), y = /* @__PURE__ */ new WeakMap(), ce = /* @__PURE__ */ new WeakMap(), He = /* @__PURE__ */ new WeakMap(), Q = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap(), be = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ new WeakMap(), Ee = /* @__PURE__ */ new WeakMap(), de = /* @__PURE__ */ new WeakMap(), Se = /* @__PURE__ */ new WeakMap(), ue = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap(), w = (t, e, n) => {
  t.getAttribute(e) !== n && t.setAttribute(e, n);
}, Z = (t, e) => {
  t.toggleAttribute("internals-disabled", e), e ? w(t, "aria-disabled", "true") : t.removeAttribute("aria-disabled"), t.formDisabledCallback && t.formDisabledCallback.apply(t, [e]);
}, Me = (t) => {
  L.get(t).forEach((n) => {
    n.remove();
  }), L.set(t, []);
}, fe = (t, e) => {
  const n = document.createElement("input");
  return n.type = "hidden", n.name = t.getAttribute("name"), t.after(n), L.get(e).push(n), n;
}, Ce = (t, e) => {
  if (e.length) {
    const n = Array.from(e);
    n.forEach((l) => l.addEventListener("click", t.click.bind(t)));
    const [a] = n;
    let i = a.id;
    a.id || (i = `${a.htmlFor}_Label`, a.id = i), w(t, "aria-labelledby", i);
  }
}, B = (t) => {
  const e = Array.from(t.elements).filter((l) => !l.tagName.includes("-") && l.validity).map((l) => l.validity.valid), n = b.get(t) || [], a = Array.from(n).filter((l) => l.isConnected).map((l) => y.get(l).validity.valid), i = [...e, ...a].includes(!1);
  t.toggleAttribute("internals-invalid", i), t.toggleAttribute("internals-valid", !i);
}, $e = (t) => {
  B(j(t.target));
}, _e = (t) => {
  B(j(t.target));
}, qe = (t) => {
  const e = [
    "button[type=submit]",
    "input[type=submit]",
    "button:not([type])"
  ].map((n) => `${n}:not([disabled])`).map((n) => `${n}:not([form])${t.id ? `,${n}[form='${t.id}']` : ""}`).join(",");
  t.addEventListener("click", (n) => {
    if (n.target.closest(e)) {
      const i = b.get(t);
      if (t.noValidate)
        return;
      i.size && Array.from(i).reverse().map((d) => y.get(d).reportValidity()).includes(!1) && n.preventDefault();
    }
  });
}, Be = (t) => {
  const e = b.get(t.target);
  e && e.size && e.forEach((n) => {
    n.constructor.formAssociated && n.formResetCallback && n.formResetCallback.apply(n);
  });
}, Fe = (t, e, n) => {
  if (e) {
    const a = b.get(e);
    if (a)
      a.add(t);
    else {
      const i = /* @__PURE__ */ new Set();
      i.add(t), b.set(e, i), qe(e), e.addEventListener("reset", Be), e.addEventListener("input", $e), e.addEventListener("change", _e);
    }
    He.set(e, { ref: t, internals: n }), t.constructor.formAssociated && t.formAssociatedCallback && setTimeout(() => {
      t.formAssociatedCallback.apply(t, [e]);
    }, 0), B(e);
  }
}, j = (t) => {
  let e = t.parentNode;
  return e && e.tagName !== "FORM" && (e = j(e)), e;
}, v = (t, e, n = DOMException) => {
  if (!t.constructor.formAssociated)
    throw new n(e);
}, he = (t, e, n) => {
  const a = b.get(t);
  return a && a.size && a.forEach((i) => {
    y.get(i)[n]() || (e = !1);
  }), e;
}, Ie = (t) => {
  let e = !1;
  if (t.constructor.formAssociated) {
    let n = y.get(t);
    n === void 0 && (t.attachInternals(), n = y.get(t), e = !0);
    const { labels: a, form: i } = n;
    Ce(t, a), Fe(t, i, n);
  }
  return e;
};
function _() {
  return typeof MutationObserver < "u";
}
const q = {
  ariaAtomic: "aria-atomic",
  ariaAutoComplete: "aria-autocomplete",
  ariaBrailleLabel: "aria-braillelabel",
  ariaBrailleRoleDescription: "aria-brailleroledescription",
  ariaBusy: "aria-busy",
  ariaChecked: "aria-checked",
  ariaColCount: "aria-colcount",
  ariaColIndex: "aria-colindex",
  ariaColIndexText: "aria-colindextext",
  ariaColSpan: "aria-colspan",
  ariaCurrent: "aria-current",
  ariaDescription: "aria-description",
  ariaDisabled: "aria-disabled",
  ariaExpanded: "aria-expanded",
  ariaHasPopup: "aria-haspopup",
  ariaHidden: "aria-hidden",
  ariaInvalid: "aria-invalid",
  ariaKeyShortcuts: "aria-keyshortcuts",
  ariaLabel: "aria-label",
  ariaLevel: "aria-level",
  ariaLive: "aria-live",
  ariaModal: "aria-modal",
  ariaMultiLine: "aria-multiline",
  ariaMultiSelectable: "aria-multiselectable",
  ariaOrientation: "aria-orientation",
  ariaPlaceholder: "aria-placeholder",
  ariaPosInSet: "aria-posinset",
  ariaPressed: "aria-pressed",
  ariaReadOnly: "aria-readonly",
  ariaRelevant: "aria-relevant",
  ariaRequired: "aria-required",
  ariaRoleDescription: "aria-roledescription",
  ariaRowCount: "aria-rowcount",
  ariaRowIndex: "aria-rowindex",
  ariaRowIndexText: "aria-rowindextext",
  ariaRowSpan: "aria-rowspan",
  ariaSelected: "aria-selected",
  ariaSetSize: "aria-setsize",
  ariaSort: "aria-sort",
  ariaValueMax: "aria-valuemax",
  ariaValueMin: "aria-valuemin",
  ariaValueNow: "aria-valuenow",
  ariaValueText: "aria-valuetext",
  role: "role"
}, je = (t, e) => {
  for (let n in q) {
    e[n] = null;
    let a = null;
    const i = q[n];
    Object.defineProperty(e, n, {
      get() {
        return a;
      },
      set(l) {
        a = l, t.isConnected ? w(t, i, l) : H.set(t, e);
      }
    });
  }
}, ze = (t, e) => {
  L.set(e, []), Te.observe?.(t, Ae);
};
function pe(t) {
  const e = y.get(t), { form: n } = e;
  Fe(t, n, e), Ce(t, e.labels);
}
const ke = (t, e = !1) => {
  const n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode(l) {
      return y.has(l) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  let a = n.nextNode();
  const i = !e || t.disabled;
  for (; a; )
    a.formDisabledCallback && i && Z(a, t.disabled), a = n.nextNode();
}, Ae = { attributes: !0, attributeFilter: ["disabled", "name"] }, Te = _() ? new MutationObserver((t) => {
  for (const e of t) {
    const n = e.target;
    if (e.attributeName === "disabled" && (n.constructor.formAssociated ? Z(n, n.hasAttribute("disabled")) : n.localName === "fieldset" && ke(n)), e.attributeName === "name" && n.constructor.formAssociated) {
      const a = y.get(n), i = be.get(n);
      a.setFormValue(i);
    }
  }
}) : {};
function X(t) {
  t.forEach((e) => {
    const { addedNodes: n, removedNodes: a } = e, i = Array.from(n), l = Array.from(a);
    i.forEach((s) => {
      if (y.has(s) && s.constructor.formAssociated && pe(s), H.has(s)) {
        const d = H.get(s);
        Object.keys(q).filter((f) => d[f] !== null).forEach((f) => {
          w(s, q[f], d[f]);
        }), H.delete(s);
      }
      if ($.has(s)) {
        const d = $.get(s);
        w(s, "internals-valid", d.validity.valid.toString()), w(s, "internals-invalid", (!d.validity.valid).toString()), w(s, "aria-invalid", (!d.validity.valid).toString()), $.delete(s);
      }
      if (s.localName === "form") {
        const d = b.get(s), h = document.createTreeWalker(s, NodeFilter.SHOW_ELEMENT, {
          acceptNode(E) {
            return y.has(E) && E.constructor.formAssociated && !(d && d.has(E)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
          }
        });
        let f = h.nextNode();
        for (; f; )
          pe(f), f = h.nextNode();
      }
      s.localName === "fieldset" && (Te.observe?.(s, Ae), ke(s, !0));
    }), l.forEach((s) => {
      const d = y.get(s);
      d && L.get(d) && Me(d), Q.has(s) && Q.get(s).disconnect();
    });
  });
}
function Ue(t) {
  t.forEach((e) => {
    const { removedNodes: n } = e;
    n.forEach((a) => {
      const i = Se.get(e.target);
      y.has(a) && Ie(a), i.disconnect();
    });
  });
}
const Ke = (t) => {
  const e = new MutationObserver(Ue);
  window?.ShadyDOM?.inUse && t.mode && t.host && (t = t.host), e.observe?.(t, { childList: !0 }), Se.set(t, e);
};
_() && new MutationObserver(X);
const G = {
  childList: !0,
  subtree: !0
};
class Ge {
  constructor() {
    this.badInput = !1, this.customError = !1, this.patternMismatch = !1, this.rangeOverflow = !1, this.rangeUnderflow = !1, this.stepMismatch = !1, this.tooLong = !1, this.tooShort = !1, this.typeMismatch = !1, this.valid = !0, this.valueMissing = !1, Object.seal(this);
  }
}
const Je = (t) => (t.badInput = !1, t.customError = !1, t.patternMismatch = !1, t.rangeOverflow = !1, t.rangeUnderflow = !1, t.stepMismatch = !1, t.tooLong = !1, t.tooShort = !1, t.typeMismatch = !1, t.valid = !0, t.valueMissing = !1, t), Qe = (t, e, n) => (t.valid = Xe(e), Object.keys(e).forEach((a) => t[a] = e[a]), n && B(n), t), Xe = (t) => {
  let e = !0;
  for (let n in t)
    n !== "valid" && t[n] !== !1 && (e = !1);
  return e;
}, J = /* @__PURE__ */ new WeakMap();
function me(t, e) {
  t.toggleAttribute(e, !0), t.part && t.part.add(e);
}
class Y extends Set {
  static get isPolyfilled() {
    return !0;
  }
  constructor(e) {
    if (super(), !e || !e.tagName || e.tagName.indexOf("-") === -1)
      throw new TypeError("Illegal constructor");
    J.set(this, e);
  }
  add(e) {
    if (!/^--/.test(e) || typeof e != "string")
      throw new DOMException(`Failed to execute 'add' on 'CustomStateSet': The specified value ${e} must start with '--'.`);
    const n = super.add(e), a = J.get(this), i = `state${e}`;
    return a.isConnected ? me(a, i) : setTimeout(() => {
      me(a, i);
    }), n;
  }
  clear() {
    for (let [e] of this.entries())
      this.delete(e);
    super.clear();
  }
  delete(e) {
    const n = super.delete(e), a = J.get(this);
    return a.isConnected ? (a.toggleAttribute(`state${e}`, !1), a.part && a.part.remove(`state${e}`)) : setTimeout(() => {
      a.toggleAttribute(`state${e}`, !1), a.part && a.part.remove(`state${e}`);
    }), n;
  }
}
var Ye = function(t, e, n, a, i) {
  if (a === "m") throw new TypeError("Private method is not writable");
  if (a === "a" && !i) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return a === "a" ? i.call(t, n) : i ? i.value = n : e.set(t, n), n;
}, ye = function(t, e, n, a) {
  if (n === "a" && !a) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !a : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? a : n === "a" ? a.call(t) : a ? a.value : e.get(t);
}, T;
class Ze {
  constructor(e) {
    T.set(this, void 0), Ye(this, T, e, "f");
    for (let n = 0; n < e.length; n++) {
      let a = e[n];
      this[n] = a, a.hasAttribute("name") && (this[a.getAttribute("name")] = a);
    }
    Object.freeze(this);
  }
  get length() {
    return ye(this, T, "f").length;
  }
  [(T = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
    return ye(this, T, "f")[Symbol.iterator]();
  }
  item(e) {
    return this[e] == null ? null : this[e];
  }
  namedItem(e) {
    return this[e] == null ? null : this[e];
  }
}
function et() {
  const t = HTMLFormElement.prototype.checkValidity;
  HTMLFormElement.prototype.checkValidity = n;
  const e = HTMLFormElement.prototype.reportValidity;
  HTMLFormElement.prototype.reportValidity = a;
  function n(...l) {
    let s = t.apply(this, l);
    return he(this, s, "checkValidity");
  }
  function a(...l) {
    let s = e.apply(this, l);
    return he(this, s, "reportValidity");
  }
  const { get: i } = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "elements");
  Object.defineProperty(HTMLFormElement.prototype, "elements", {
    get(...l) {
      const s = i.call(this, ...l), d = Array.from(b.get(this) || []);
      if (d.length === 0)
        return s;
      const h = Array.from(s).concat(d).sort((f, E) => f.compareDocumentPosition ? f.compareDocumentPosition(E) & 2 ? 1 : -1 : 0);
      return new Ze(h);
    }
  });
}
class ge {
  static get isPolyfilled() {
    return !0;
  }
  constructor(e) {
    if (!e || !e.tagName || e.tagName.indexOf("-") === -1)
      throw new TypeError("Illegal constructor");
    const n = e.getRootNode(), a = new Ge();
    this.states = new Y(e), g.set(this, e), D.set(this, a), y.set(e, this), je(e, this), ze(e, this), Object.seal(this), n instanceof DocumentFragment && Ke(n);
  }
  /**
   * Will return true if the element is in a valid state
   */
  checkValidity() {
    const e = g.get(this);
    if (v(e, "Failed to execute 'checkValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
      return !0;
    const n = D.get(this);
    if (!n.valid) {
      const a = new Event("invalid", {
        bubbles: !1,
        cancelable: !0,
        composed: !1
      });
      e.dispatchEvent(a);
    }
    return n.valid;
  }
  /** The form element the custom element is associated with */
  get form() {
    const e = g.get(this);
    v(e, "Failed to read the 'form' property from 'ElementInternals': The target element is not a form-associated custom element.");
    let n;
    return e.constructor.formAssociated === !0 && (n = j(e)), n;
  }
  /** A list of all relative form labels for this element */
  get labels() {
    const e = g.get(this);
    v(e, "Failed to read the 'labels' property from 'ElementInternals': The target element is not a form-associated custom element.");
    const n = e.getAttribute("id"), a = e.getRootNode();
    return a && n ? a.querySelectorAll(`[for="${n}"]`) : [];
  }
  /** Will report the elements validity state */
  reportValidity() {
    const e = g.get(this);
    if (v(e, "Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
      return !0;
    const n = this.checkValidity(), a = de.get(this);
    if (a && !e.constructor.formAssociated)
      throw new DOMException("Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element.");
    return !n && a && (e.focus(), a.focus()), n;
  }
  /** Sets the element's value within the form */
  setFormValue(e) {
    const n = g.get(this);
    if (v(n, "Failed to execute 'setFormValue' on 'ElementInternals': The target element is not a form-associated custom element."), Me(this), e != null && !(e instanceof FormData)) {
      if (n.getAttribute("name")) {
        const a = fe(n, this);
        a.value = e;
      }
    } else e != null && e instanceof FormData && Array.from(e).reverse().forEach(([a, i]) => {
      if (typeof i == "string") {
        const l = fe(n, this);
        l.name = a, l.value = i;
      }
    });
    be.set(n, e);
  }
  /**
   * Sets the element's validity. The first argument is a partial ValidityState object
   * reflecting the changes to be made to the element's validity. If the element is invalid,
   * the second argument sets the element's validation message.
   *
   * If the field is valid and a message is specified, the method will throw a TypeError.
   */
  setValidity(e, n, a) {
    const i = g.get(this);
    if (v(i, "Failed to execute 'setValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !e)
      throw new TypeError("Failed to execute 'setValidity' on 'ElementInternals': 1 argument required, but only 0 present.");
    de.set(this, a);
    const l = D.get(this), s = {};
    for (const f in e)
      s[f] = e[f];
    Object.keys(s).length === 0 && Je(l);
    const d = { ...l, ...s };
    delete d.valid;
    const { valid: h } = Qe(l, d, this.form);
    if (!h && !n)
      throw new DOMException("Failed to execute 'setValidity' on 'ElementInternals': The second argument should not be empty if one or more flags in the first argument are true.");
    ce.set(this, h ? "" : n), i.isConnected ? (i.toggleAttribute("internals-invalid", !h), i.toggleAttribute("internals-valid", h), w(i, "aria-invalid", `${!h}`)) : $.set(i, this);
  }
  get shadowRoot() {
    const e = g.get(this), n = Ee.get(e);
    return n || null;
  }
  /** The element's validation message set during a call to ElementInternals.setValidity */
  get validationMessage() {
    const e = g.get(this);
    return v(e, "Failed to read the 'validationMessage' property from 'ElementInternals': The target element is not a form-associated custom element."), ce.get(this);
  }
  /** The current validity state of the object */
  get validity() {
    const e = g.get(this);
    return v(e, "Failed to read the 'validity' property from 'ElementInternals': The target element is not a form-associated custom element."), D.get(this);
  }
  /** If true the element will participate in a form's constraint validation. */
  get willValidate() {
    const e = g.get(this);
    return v(e, "Failed to read the 'willValidate' property from 'ElementInternals': The target element is not a form-associated custom element."), !(e.matches(":disabled") || e.disabled || e.hasAttribute("disabled") || e.hasAttribute("readonly"));
  }
}
function tt() {
  if (typeof window > "u" || !window.ElementInternals || !HTMLElement.prototype.attachInternals)
    return !1;
  class t extends HTMLElement {
    constructor() {
      super(), this.internals = this.attachInternals();
    }
  }
  const e = `element-internals-feature-detection-${Math.random().toString(36).replace(/[^a-z]+/g, "")}`;
  customElements.define(e, t);
  const n = new t();
  return [
    "shadowRoot",
    "form",
    "willValidate",
    "validity",
    "validationMessage",
    "labels",
    "setFormValue",
    "setValidity",
    "checkValidity",
    "reportValidity"
  ].every((a) => a in n.internals);
}
let ve = !1, we = !1;
function Le(t) {
  we || (we = !0, window.CustomStateSet = Y, t && (HTMLElement.prototype.attachInternals = function(...e) {
    const n = t.call(this, e);
    return n.states = new Y(this), n;
  }));
}
function nt(t = !0) {
  let e = !1;
  if (!ve) {
    if (ve = !0, typeof window < "u" && (window.ElementInternals = ge), typeof CustomElementRegistry < "u") {
      const a = CustomElementRegistry.prototype.define;
      CustomElementRegistry.prototype.define = function(i, l, s) {
        if (l.formAssociated) {
          const d = l.prototype.connectedCallback;
          l.prototype.connectedCallback = function() {
            ue.has(this) || (ue.set(this, !0), this.hasAttribute("disabled") && Z(this, !0)), d?.apply(this), e = Ie(this);
          };
        }
        a.call(this, i, l, s);
      };
    }
    if (typeof HTMLElement < "u" && (HTMLElement.prototype.attachInternals = function() {
      if (this.tagName) {
        if (this.tagName.indexOf("-") === -1)
          throw new Error("Failed to execute 'attachInternals' on 'HTMLElement': Unable to attach ElementInternals to non-custom elements.");
      } else return {};
      if (y.has(this) && !e)
        throw new DOMException("DOMException: Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.");
      return new ge(this);
    }), typeof Element < "u") {
      let a = function(...l) {
        const s = i.apply(this, l);
        if (Ee.set(this, s), _()) {
          const d = new MutationObserver(X);
          window.ShadyDOM ? d.observe(this, G) : d.observe(s, G), Q.set(this, d);
        }
        return s;
      };
      var n = a;
      const i = Element.prototype.attachShadow;
      Element.prototype.attachShadow = a;
    }
    _() && typeof document < "u" && new MutationObserver(X).observe(document.documentElement, G), typeof HTMLFormElement < "u" && et(), (t || typeof window < "u" && !window.CustomStateSet) && Le();
  }
}
const at = !!customElements.polyfillWrapFlushCallback;
at || (tt() ? typeof window < "u" && !window.CustomStateSet && Le(HTMLElement.prototype.attachInternals) : nt(!1));
